import axios from '@/lib/axios';
import { TerminateRequestParams } from '../types';

const createTerminate = (data: TerminateRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/facility_agreements/terminate_cancels/${custCode}/terminate_create`, data);
}

export default createTerminate;